export enum AcceptedCountries {
  SENEGAL = "SENEGAL",
  CHAD = "CHAD",
}
export type UserInfo = {
  id?: string;
  photoUrl: string;
  email: string;
  civility: CivilityType;
  roleName: RoleType;
  firstName: string;
  phoneNumber: string;
  lastName: string;
  paymentPhoneNumber?: string;
  preferredNotificationMethods: NotificationPrefType[];
  dateOfBirth?: string;
  // The BFF sends and expects a LIST named `locations`; a singular `location`
  // was never populated, which is why the admin never showed an address (MED-1423).
  locations?: Location[];
};

export type Location = {
  // Sent by the BFF on a user's addresses; absent on a facility location.
  isPrimary?: boolean;
  address?: string;
  city?: string;
  country?: AcceptedCountries;
  state?: string;
  zip?: string;
  accessInformation?: string;
  coordinates?: {
    lat: number;
    lng: number;
  };
};

export type CivilityType = (typeof CivilityEnum)[keyof typeof CivilityEnum];

export const CivilityEnum = {
  MRS: "WOMAN",
  MR: "MAN",
};

export type NotificationPrefType =
  (typeof NotificationPrefEnum)[keyof typeof NotificationPrefEnum];

export const NotificationPrefEnum = {
  SMS: "SMS",
  EMAIL: "EMAIL",
};
export type RoleType = (typeof RoleEnum)[keyof typeof RoleEnum];

export const RoleEnum = {
  ADMIN: "ADMIN",
  PATIENT: "PATIENT",
  DOCTOR: "DOCTOR",
  MANAGER: "MANAGER",
  SUPER_ADMIN: "SUPER_ADMIN",
};
export type EditableUserInfo = Omit<
  UserInfo,
  "preferredNotificationMethods"
> & {
  preferredNotificationMethods: {
    value: NotificationPrefType;
    label: NotificationPrefType;
  }[];
};

/**
 * MED-1448: the extra read-only fields `GET /users/{id}` returns on top of
 * `UserInfo`. The admin profile page shows them but cannot change them.
 */
export type UserProfileDetails = UserInfo & {
  accountVerified?: boolean;
  disabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
};
